import React, { useState, useEffect } from "react";
import { defineMessages } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { produce } from "immer";
import { makeStyles } from "tss-react/mui";
import { Button } from "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import { BulkModalContent } from "../../../components/modal/BulkModalContent.js";
import "../../../components/modal/BulkModalProvider.js";
import { BulkModalTitle } from "../../../components/modal/BulkModalTitle.js";
import "../../../components/modal/ModalButtons.js";
import { ModalFooter } from "../../../components/modal/ModalFooter.js";
import "@mui/material";
import "../../../components/modal/Modal.style.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import "../../../components/error/GlobalServerErrorMessage.js";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import { TransactionType } from "../../../contract/pam.js";
import { bulkActionsActions } from "../../bulk-operation/actions.js";
import "../../bulk-operation/components/BulkActionButton.js";
import "../../bulk-operation/epics.js";
import "../../bulk-operation/hooks.js";
import "../../bulk-operation/reducers.js";
import { itemsSelector } from "../../bulk-operation/selectors.js";
import "rxjs";
import "../../../api/types.js";
import "moment-timezone";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../bulk-operation/components/BulkExecutionStepDetailsContent.js";
import "../../bulk-operation/components/BulkExecutionStepModal.js";
import "../../bulk-operation/components/BulkSummaryStepActionItem.js";
import "../../bulk-operation/components/BulkSummaryStepHoc.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "../../bulk-operation/components/DataGrid.js";
import "../../bulk-operation/components/BulkStepValidationSummary.js";
import "../../../components/progress/CircularProgress.js";
import "../../../components/progress/CircularProgressWithLabel.js";
import "../../bulk-operation/components/BulkSummaryStepActionLabel.js";
import { DataGridTransactionWithUserProfileEditableClient } from "./DataGridWithUserProfileEditable.js";
const useClasses = makeStyles()(() => ({
  p2pTransferGrid: {
    height: "500px",
    flex: "auto"
  }
}));
const localized = defineMessages({
  title: {
    id: "BulkStepApplyP2PTransfer_title",
    defaultMessage: "P2P Transfer"
  },
  prev: {
    id: "BulkStepApplyP2PTransfer_prev",
    defaultMessage: "Cancel"
  },
  next: {
    id: "BulkStepApplyP2PTransfer_next",
    defaultMessage: "Validate"
  }
});
const defaultGridColumns = ["uid", "p2p_direction", "finance.balance", "p2p_transfer_amount_editable"];
function BulkTransactionP2PTransferApplyStepModal({
  onPrev,
  onNext,
  strategy,
  gridColumns = defaultGridColumns
}) {
  const { classes } = useClasses();
  const dispatch = useDispatch();
  const selectedItems = useSelector(itemsSelector);
  const [items, setItems] = useState(getDefaultValues);
  useEffect(() => {
    setItems(getDefaultValues());
  }, [selectedItems?.map((i) => i.uid)?.join()]);
  function getDefaultValues() {
    const currency = "USD";
    return selectedItems?.map((i) => ({
      id: i.id,
      serverId: i.serverId,
      uid: i.uid,
      username: i.username,
      transaction_type: i.transaction_type ?? TransactionType.P2PTransferCredit,
      amount: i.amount ?? 0,
      finance: i.finance,
      currency
    }));
  }
  const handleCellValueChange = (newRow, oldRow) => {
    const updatedItems = produce(items, (draft) => {
      const amount = "p2p_transfer_amount_editable";
      const direction = "p2p_direction_editable";
      const updatedItem = draft?.find((i) => i.id === newRow.id);
      if (Number(newRow[amount].amount) !== oldRow.amount) {
        updatedItem.amount = Number(newRow[amount].amount) ?? 0;
      }
      if (newRow[direction] !== oldRow[direction]) {
        updatedItem.transaction_type = newRow[direction];
      }
    });
    setItems(updatedItems);
    dispatch(bulkActionsActions.setBulkActionsItems(updatedItems));
    return updatedItems.find((i) => i.id === newRow.id);
  };
  function handleNextClick() {
    const request = { transactions: items };
    dispatch(bulkActionsActions.apply({ strategy, request }));
    onNext();
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BulkModalTitle, { title: localized.title }), /* @__PURE__ */ React.createElement(BulkModalContent, null, /* @__PURE__ */ React.createElement(
    DataGridTransactionWithUserProfileEditableClient,
    {
      className: classes.p2pTransferGrid,
      columns: gridColumns,
      rows: items,
      rawModels: items?.map((i) => ({ isValid: true, raw: JSON.stringify(i) })),
      processRowUpdate: handleCellValueChange
    }
  )), /* @__PURE__ */ React.createElement(ModalFooter, null, /* @__PURE__ */ React.createElement(Button, { label: localized.prev, onClick: onPrev }), /* @__PURE__ */ React.createElement(Button, { color: "primary", label: localized.next, onClick: handleNextClick, disabled: false })));
}
export {
  BulkTransactionP2PTransferApplyStepModal
};
//# sourceMappingURL=BulkP2PTransferApplyStepModal.js.map
